<template>
  <div id="promotion-overlay" class="modal-overlay" > 
    <iframe v-if="promotionFrameSrc" class="modal" :src="promotionFrameSrc" />                
  </div>
</template>

<script>
import api from '@groovepages/gd-lib/api';
export default {
  data() {
    return {
      promotionFrameSrc: ''
    };
  },
  created(){
    this.isToShow();
  },
  methods:{
    addHTTP(url) {
      if (url.match(/^(http|https)?:\/\//i)) {
        return url;
      }
      return `https://${url}`;
    },
    isToShow() {
      if(localStorage.getItem('show_promotion') === 'true') {
      //localStorage.getItem('LAST_PROMOTION_SHOWN_DATE') != new Date().setHours(0,0,0,0) 
        api
          .get(
            `${window.gdEnv.VUE_APP_API_URL}/groovepages/promotion`
          )
          .then(data => {
            if(data?.publish_url) {
              this.showModal(); 
              this.promotionFrameSrc = this.addHTTP(data.publish_url);
            } 
          })
      }
    },
    showModal() {
      const modalOverlay = document.querySelector("#promotion-overlay");
      modalOverlay.classList.toggle("visible");
      modalOverlay.addEventListener('click', this.hideModal);
      localStorage.setItem('show_promotion', false);
      //localStorage.setItem('LAST_PROMOTION_SHOWN_DATE', new Date().setHours(0,0,0,0));
    },
    hideModal() {
      const modalOverlay = document.querySelector("#promotion-overlay");
      modalOverlay.classList.toggle("visible");
      this.promotionFrameSrc = '';
    }
  }
};
</script>

<style scoped>
.modal {
  z-index: 1000;
  position: fixed; 
  top: 50%; 
  left:50%; 
  transform: translate(-50%, -50%); 
  width: 600px;
  max-width: 100%;
  height: 400px;
  max-height: 100%;
  background-color: rgba(255, 255, 255, 1);
}

.modal-overlay {
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  overflow: hidden;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-overlay.visible {
  width: 100%;
  height: 100%;
  opacity: 1;
}
</style>
